angular.module(NgAppName).component('crComponentPagination', {
	templateUrl: 'crComponentPagination.html', 
	bindings: {
		pagination: '<',
		pageLinkAmount: '@',
		onGetListings: '&',
		isMobile: '<',
		contentId: '@'
	},
	controller: ['$anchorScroll', '$element', function($anchorScroll, $element) {
		var ctrl = this;
		var pageLinkAmount = ctrl.pageLinkAmount || 9;
		this.$onChanges = function(changes) {
			if (changes.pagination && changes.pagination.currentValue) {
				ctrl.singlePage = ctrl.pagination.rowsPerPage >= ctrl.pagination.total;
				if (ctrl.isMobile) {
					if(!ctrl.lazyIsPlaced) {
						ctrl.moveButtons();
					}
					ctrl.setMobilePages();
				} else {
					ctrl.setDesktopPages();
				}
			}
		};

		this.moveButtons = function() {
			var $prev = angular.element($element[0].querySelector('#prev'));
			var $content = angular.element(document.querySelector('#' + this.contentId));
			$prev.insertBefore($content);
			ctrl.lazyIsPlaced = true;
		};

		this.setMobilePages = function() {
			var maxPage = Math.ceil(this.pagination.total / this.pagination.rowsPerPage);
			var currentPage = parseInt(this.pagination.currentPage, 10);

			if (currentPage !== maxPage) {
				this.nextPage = currentPage + 1;
			} else {
				this.nextPage = null;
			}

			if (currentPage !== 1) {
				this.previousPage = currentPage - 1;
			} else {
				this.previousPage = null;
			}
		};

		this.setDesktopPages = function() {
			var maxPage = Math.ceil(this.pagination.total / this.pagination.rowsPerPage);
			var currentPage = parseInt(this.pagination.currentPage, 10);
			this.pages = [];
			this.firstPage = this.lastPage = this.previousPage = this.nextPage = null;

			if (maxPage <= pageLinkAmount) {
				for (var j = 1; j <= maxPage; j++) {
					this.pages.push(j);
				}
			} else {
				var first;
				var last;

				if (currentPage <= Math.ceil(pageLinkAmount / 2)) { //very beginning
					first = 1;
					last = pageLinkAmount;
				} else if (currentPage >= maxPage - Math.floor(pageLinkAmount / 2)) { //very end
					first = maxPage - pageLinkAmount + 1;
					last = maxPage;
				} else { //middle
					first = currentPage - Math.floor(pageLinkAmount / 2);
					first += pageLinkAmount % 2 === 0 ? 1 : 0;
					last = currentPage + Math.floor(pageLinkAmount / 2);
				}

				for (var k = first; k <= last; k++) {
					this.pages.push(k);
				}
			}

			if (currentPage > 1) {
				this.firstPage = 1;
				this.previousPage = currentPage - 1;
			}

			if (currentPage < maxPage) {
				this.lastPage = maxPage;
				this.nextPage = currentPage + 1;
			}
		};
 
		this.jumpToPage = function(page) {
			this.pagination.currentPage = page;
			this.onGetListings({page});
		};

		this.backToTop = function() {
			$anchorScroll();
		};
	}]
});
